export const SET_GET_INSTANCES_REQUEST = "SET_GET_INSTANCES_REQUEST";
export const SET_GET_INSTANCES_SUCCESS = "SET_GET_INSTANCES_SUCCESS";
export const SET_GET_INSTANCES_ERROR = "SET_GET_INSTANCES_ERROR";
export const SET_SELECT_INSTANCE = "SET_SELECT_INSTANCE";

// For restructured APM Dashboard.
export const SET_GET_AVAILABLE_INSTANCES_REQUEST = "SET_GET_AVAILABLE_INSTANCES_REQUEST";
export const SET_GET_AVAILABLE_INSTANCES_SUCCESS = "SET_GET_AVAILABLE_INSTANCES_SUCCESS";
export const SET_GET_AVAILABLE_INSTANCES_ERROR = "SET_GET_AVAILABLE_INSTANCES_ERROR";

// For restructured APM Dashboard.
export const SET_ALL_AVAILABLE_DOCKERS_REQUEST = 'SET_ALL_AVAILABLE_DOCKERS_REQUEST';
export const SET_ALL_AVAILABLE_DOCKERS_SUCCESS = 'SET_ALL_AVAILABLE_DOCKERS_SUCCESS';
export const SET_ALL_AVAILABLE_DOCKERS_ERROR = 'SET_ALL_AVAILABLE_DOCKERS_ERROR';
